"use client";
'use strict';

var React = require('react');
var auth = require('@sravni/utils/lib/auth');

const generateLinkProps = (data) => {
    const { isNewWindow, disabled = false, ...rest } = data;
    const href = auth.getLoginUrl({ isNewWindow, ...rest });
    const rel = isNewWindow ? 'opener' : undefined;
    const target = isNewWindow ? '_blank' : undefined;
    const style = {
        // Выключаем клик по ссылке пока не отработает гидратация React
        // Если пользователь успеет нажать раньше, то не будет запущен слушатель postMessage(в проекте)
        // и пользователь останется на белом экране (если isNewWindow === true)
        pointerEvents: disabled ? 'none' : 'auto',
    };
    return {
        href,
        style,
        ...(rel ? { rel } : {}),
        ...(target ? { target } : {}),
    };
};
function useAuthLoginLink(props) {
    const [linkProps, setLinkProps] = React.useState(() => generateLinkProps({ ...props, disabled: true }));
    React.useEffect(() => {
        setLinkProps(generateLinkProps({ ...props, disabled: false }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, Object.values(props || {}));
    return linkProps;
}

exports.useAuthLoginLink = useAuthLoginLink;
//# sourceMappingURL=useAuthLoginLink.js.map
